import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHouseShoes = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1436_996)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M20.9045 13.5002H14.1089L11.3141 9.26501C11.1721 9.04789 10.893 8.94938 10.6357 9.0255L4.17407 10.9086C3.17594 11.1965 2.49497 12.0701 2.4983 13.0586V14.0627C2.4983 14.0626 2.4983 14.063 2.4983 14.0627C2.49849 14.3732 2.7643 14.6254 3.09205 14.6252H13.7795H20.9045C21.2325 14.6252 21.4983 14.3734 21.4983 14.0627C21.4983 13.7521 21.2324 13.5002 20.9045 13.5002ZM3.6858 13.5002V13.0586C3.68454 12.5642 4.0251 12.1273 4.52424 11.983L10.5487 10.2274L12.708 13.5002H3.6858Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1436_996",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 19,
			height: 6,
			fill: "white",
			transform: "translate(2.5 9)"
		})
	}) })]
});
export default SvgHouseShoes;
